// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__oByL9","icons-container":"Footer_icons-container__uGf7M"};